import React from 'react';

const Guess = ({ procedure, onConfirm, onReject }) => {
  return (
    <div className="guess-container">
      <h2>Est-ce que c'est ce que vous cherchez ?</h2>
      <div className="procedure-card">
        <h3>{procedure.name}</h3>
        <p>{procedure.description}</p>
        {procedure.link && procedure.link !== '#' && (
          <a href={procedure.link} target="_blank" rel="noopener noreferrer">
            Lien vers la démarche officielle
          </a>
        )}
      </div>
      <div className="confirmation-buttons">
        <button className="confirm" onClick={onConfirm}>
          Oui, c'est bien ça !
        </button>
        <button className="reject" onClick={onReject}>
          Non, ce n'est pas ça.
        </button>
      </div>
    </div>
  );
};

export default Guess;